<ng-container *ngIf="content">
  <div class="banner" [class.banner--no-padding-bottom]="!paddingBottom" [style.backgroundColor]="backgroundColor">
    <div class="banner-text-container">
      <h2 class="banner-text-container__heading" [innerHTML]="content.fields.title"></h2>
      <span class="banner-text-container__ingress">{{ content.fields.ingress }}</span>
    </div>
  </div>
</ng-container>
